import React from "react";
import "../manage_users.css";

type Props = {
  isOpen: boolean;
  selectedUserName: string;
  selectedUserRole: string;
  selectedUserLastActive: string;
  selectedUserCurrentBalance: string | number;
  selectedUserUsedCredits: string | number;
  selectedUserTotalAssigned: string | number;
  userStatus: boolean;
  onBack: () => void;
  onToggleStatus: () => void;
  onResetPassword: () => void;
  onDeleteUser: () => void;
  canDeleteUser: boolean;
  onRemoveCredits: () => void;
  onAssignCredits: () => void;
};

const UserDetailsPanel: React.FC<Props> = ({
  isOpen,
  selectedUserName,
  selectedUserRole,
  selectedUserLastActive,
  selectedUserCurrentBalance,
  selectedUserUsedCredits,
  selectedUserTotalAssigned,
  userStatus,
  onBack,
  onToggleStatus,
  onResetPassword,
  onDeleteUser,
  canDeleteUser,
  onRemoveCredits,
  onAssignCredits,
}) => {
  return (
    <div className={`slider-panel details-panel ${isOpen ? "slide-in" : ""}`}>
      <div className="user-management-box">
        <p className="user-detailss" style={{ cursor: "pointer" }} onClick={onBack}>
          <img src="/images/icon-fi-rs-angle-small-left.png" width="10" alt="" /> Back
        </p>

        <div className="user-managment-box-details">
          <div className="details-box">
            <div className="user-manage-blue">
              <div className="row">
                <div className="col-md-3">
                  <div className="row align-items-center">
                    <div className="col-auto p-0">
                      <img
                        src="/images/blank-ing.png"
                        className="blank-img"
                        alt=""
                      />
                    </div>

                    <div className="col p-0">
                      <p className="user-name-m mb-1">{selectedUserName}</p>
                      <p className="Member-user mb-0">{selectedUserRole}</p>
                    </div>
                  </div>
                  <p className="last-option">Last Active: {selectedUserLastActive}</p>
                </div>

                <div className="col-md-8">
                  <div className="user-white-box">
                    <div className="row text-center">
                      <div className="col-md-3 border-end">
                        <p className="current-balance">Current Balance</p>
                        <p className="current-number">{selectedUserCurrentBalance}</p>
                      </div>

                      <div className="col-md-3 border-end">
                        <p className="current-balance">Used Credits</p>
                        <p className="current-number">{selectedUserUsedCredits}</p>
                      </div>

                      <div className="col-md-3 border-end">
                        <p className="current-balance">Total Assigned</p>
                        <p className="current-number">{selectedUserTotalAssigned}</p>
                      </div>

                      <div className="col-md-3">
                        <p className="current-balance">Status</p>
                        <div
                          className={`status-switch ${userStatus ? "active" : ""}`}
                          onClick={onToggleStatus}
                        >
                          <span className="status-label status-off">INACTIVE</span>
                          <span className="status-label status-on">ACTIVE</span>
                          <span className="status-handle"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between mt-3">
              <div className="d-flex flex-row">
                <div>
                  <p className="reset-password" onClick={onResetPassword}>
                    Reset Password
                  </p>
                </div>
                <div className="max-line">
                 
                </div>
                <div>
                  <p
                    className="delete-user"
                    onClick={onDeleteUser}
                    style={{ cursor: canDeleteUser ? "pointer" : "not-allowed", opacity: canDeleteUser ? 1 : 0.5 }}
                  >
                    Delete User
                  </p>
                </div>
              </div>
              <div className="d-flex flex-row">
                <div>
                  <button type="button" className="remove" onClick={onRemoveCredits}>
                    Remove Credits
                  </button>
                </div>
                <div>
                  <button type="button" className="assign" onClick={onAssignCredits}>
                    Assign Credits
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsPanel;
